import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import 'clsx';
import '../../base/addButton/AddButton.module.scss.js';
import '../../base/alert/Alert.js';
import '../../base/breadcrumb/Breadcrumb.module.scss.js';
import '../../base/button/Button.js';
import 'react-aria';
import 'react-stately';
import 'react';
import '../../base/iconButton/IconButton.js';
import '../../base/calendar/Calendar.module.scss.js';
import 'dayjs';
import '../../base/calendar/calendarGrid/CalendarGrid.module.scss.js';
import '../../base/calendar/calendarGrid/calendarCell/CalendarCell.module.scss.js';
import '../../base/carBackground/CarBackground.module.scss.js';
import '../../base/loader/Loader.module.scss.js';
import '../../base/carLoader/CarLoader.module.scss.js';
import '../../base/card/Card.js';
import '../../base/confirmation/Confirmation.js';
import '../../base/modal/Modal.js';
import '../../base/confirmationModal/ConfirmationModal.module.scss.js';
import '../../base/error/Error.module.scss.js';
import '../../base/tag/Tag.module.scss.js';
import '../../base/vehicleQuote/VehicleQuote.module.scss.js';
import '../../base/insuranceQuote/InsuranceQuote.module.scss.js';
import '../../base/listBox/ListBox.js';
import { ListCard } from '../../base/listCard/ListCard.js';
import 'react-dom';
import 'react-transition-group';
import '../../base/popover/Popover.module.scss.js';
import '../../base/progressBar/ProgressBar.module.scss.js';
import 'react-timer-hook';
import 'react-use';
import '../../base/sessionTimeoutWarning/SessionTimeoutWarning.module.scss.js';
import '../../base/toast/context/ToastContext.js';
import '../../base/toast/Toast.module.scss.js';
import '../../base/toast/context/ToastContext.module.scss.js';
import '../../base/tooltip/Tooltip.module.scss.js';
import { ButtonSkeleton } from '../buttonSkeleton/ButtonSkeleton.js';
import styles from './PolicySectionSkeleton.module.scss.js';

var Item = function () { return (jsx(ListCard.Row, { children: jsxs("div", __assign({ className: styles.sectionDetailRow }, { children: [jsx("div", { className: styles.skeleton }), jsx("div", { className: styles.skeleton })] })) })); };
var Button = function () { return (jsx("div", __assign({ className: styles.sectionDetailRow }, { children: jsx(ButtonSkeleton, {}) }))); };
var PolicySectionSkeleton = function (_a) {
    var className = _a.className, style = _a.style, title = _a.title, hasButton = _a.hasButton;
    return (jsxs(ListCard, __assign({ className: className, style: style }, { children: [title && jsx(ListCard.Header, { children: title }), jsx(Item, {}), jsx(Item, {}), jsx(Item, {}), jsx(Item, {}), hasButton && (jsx(ListCard.Footer, __assign({ className: styles.footer }, { children: jsx(Button, {}) })))] })));
};

export { PolicySectionSkeleton };
